module.exports = __webpack_public_path__ + "img/feature_b03.738615b0.svg";